/**
 * Translator
 * Handles multi-language translations for the form
 */

export class Translator {
  constructor() {
    this.translations = {};
    this.currentLanguage = 'en';
  }

  /**
   * Load translations for a language
   * @param {string} language - Language code (en, he, fr, es, nl, ar)
   * @returns {Promise}
   */
  async loadLanguage(language = 'en') {
    this.currentLanguage = language;
    
    try {
      const response = await fetch(`/tqtag/js/form/dist/translations/${language}.json`);
      if (!response.ok) {
        // Fallback to English if language file not found
        if (language !== 'en') {
          return this.loadLanguage('en');
        }
        throw new Error(`Failed to load translations: ${response.statusText}`);
      }
      
      this.translations = await response.json();
      return this.translations;
    } catch (error) {
      // Fallback to English
      if (language !== 'en') {
        return this.loadLanguage('en');
      }
      // If English also fails, use empty translations
      this.translations = {};
      return {};
    }
  }

  /**
   * Get translated string
   * @param {string} key - Translation key (e.g., 'errors.entry_too_short')
   * @param {Object} params - Parameters to replace in translation (e.g., {min: 5})
   * @returns {string}
   */
  t(key, params = {}) {
    const keys = key.split('.');
    let value = this.translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key;
      }
    }
    
    // Replace parameters in the translation string
    if (typeof value === 'string' && Object.keys(params).length > 0) {
      return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
        return params[paramKey] !== undefined ? params[paramKey] : match;
      });
    }
    
    return value || key;
  }

  /**
   * Get current language
   * @returns {string}
   */
  getCurrentLanguage() {
    return this.currentLanguage;
  }
}

